module.exports = __webpack_public_path__ + "img/cb-reset.9d9390ff.svg";